import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";
import { lenisStore } from "@/lib/lenis";

export function useSmoothScroll() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ lerp: 0.09 });
    lenisStore.current = lenis;
    let frame = requestAnimationFrame(function loop(time) {
      lenis.raf(time);
      frame = requestAnimationFrame(loop);
    });
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
      lenisStore.current = null;
    };
  }, []);

  useEffect(() => {
    const timer = setTimeout(
      () => {
        const lenis = lenisStore.current;
        const target = hash ? document.getElementById(decodeURIComponent(hash.slice(1))) : null;
        if (target) {
          if (lenis) lenis.scrollTo(target, { offset: -96 });
          else target.scrollIntoView();
          return;
        }
        if (lenis) lenis.scrollTo(0, { immediate: true });
        else window.scrollTo(0, 0);
      },
      hash ? 150 : 0,
    );
    return () => clearTimeout(timer);
  }, [pathname, hash]);
}
